export const TABLET = '(max-width: 1265px)';
